import { useSelector } from "react-redux";

import { selectCardLimitsByCardId } from "./selectors";

export const useCardLimits = (id: API.CardId) => {
  return useSelector(selectCardLimitsByCardId(id));
};
